
const ParticleBackground = () => {
  return <div className="particle-background" aria-hidden="true" />;
};

export default ParticleBackground;
